// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608041955/js/" + chunkId + "." + {"44":"36497503","225":"6fbe48f9","481":"42cebdbd","486":"5c08fa18","770":"70b2d269"}[chunkId] + ".0.6099028465476735.chunk.js";
};